
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

// Extend the Window interface to include chatbase
declare global {
  interface Window {
    chatbase: any;
  }
}

const AIChatbot = () => {
  const scriptLoaded = useRef(false);
  const location = useLocation();

  // Don't render on admin page
  if (location.pathname === '/mukesh') {
    return null;
  }

  useEffect(() => {
    // Only load the script once
    if (scriptLoaded.current) return;

    // Initialize Chatbase with secure identity verification
    const initializeChatbase = async () => {
      if (!window.chatbase || window.chatbase("getState") !== "initialized") {
        window.chatbase = (...args: any[]) => {
          if (!window.chatbase.q) {
            window.chatbase.q = [];
          }
          window.chatbase.q.push(args);
        };
        
        window.chatbase = new Proxy(window.chatbase, {
          get(target, prop) {
            if (prop === "q") {
              return target.q;
            }
            return (...args: any[]) => target(prop, ...args);
          }
        });
      }

      try {
        // Get the identity verification key securely
        const { data } = await supabase.functions.invoke('chatbase-identity');
        
        const script = document.createElement('script');
        script.src = 'https://www.chatbase.co/embed.min.js';
        script.id = 'HtAa9FzJKZiCdcyR9-Gxe';
        script.setAttribute('data-domain', 'www.chatbase.co');
        
        // Set up identity verification after script loads
        script.onload = () => {
          if (window.chatbase && data?.identityKey) {
            window.chatbase('config', {
              identityKey: data.identityKey
            });
          }
        };
        
        document.body.appendChild(script);
        scriptLoaded.current = true;
      } catch (error) {
        console.error('Failed to initialize chatbase with identity verification:', error);
        
        // Fallback: Initialize without identity verification
        const script = document.createElement('script');
        script.src = 'https://www.chatbase.co/embed.min.js';
        script.id = 'HtAa9FzJKZiCdcyR9-Gxe';
        script.setAttribute('data-domain', 'www.chatbase.co');
        document.body.appendChild(script);
        scriptLoaded.current = true;
      }
    };

    if (document.readyState === 'complete') {
      initializeChatbase();
    } else {
      window.addEventListener('load', initializeChatbase);
    }

    // Cleanup function
    return () => {
      window.removeEventListener('load', initializeChatbase);
    };
  }, []);

  return (
    <div className="fixed bottom-20 right-4 z-40">
      {/* The Chatbase widget will be injected here by the external script */}
    </div>
  );
};

export default AIChatbot;
